The details of the `CandidateProcessHistoryItem` to be added to the `CandidateProfile`.
